import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { MyPageTopicGroupDetail } from '@/Interfaces/I_MyPage';

const initialState = {
  value: {
    topicGroups: [] as MyPageTopicGroupDetail[],
    topics: [] as string[],
  },
  loading: false,
  error: '',
};

const myPageSlice = createSlice({
  name: 'myPageSlice',
  initialState,
  reducers: {
    getMyPageTopicGroups: (state) => {
      const assignState = state;
      assignState.loading = true;
    },
    setMyPageTopicGroups: (state, action: PayloadAction<MyPageTopicGroupDetail[]>) => {
      const assignState = state;
      assignState.value.topicGroups = action.payload;
      assignState.loading = false;
    },
    setErrorMessage: (state, action) => {
      const assignState = state;
      assignState.loading = false;
      assignState.error = action.payload;
    },
    getMyPageTopics: (state) => {
      const assignState = state;
      assignState.loading = true;
    },
    setMyPageTopics: (state, action: PayloadAction<string[]>) => {
      const assignState = state;
      assignState.value.topics = action.payload;
      assignState.loading = false;
    },
    updateMyPageTopicGroups: (state, _action: PayloadAction<MyPageTopicGroupDetail[]>) => {
      const assignState = state;
      assignState.loading = true;
    },
  },
});

export const {
  getMyPageTopicGroups,
  setMyPageTopicGroups,
  setErrorMessage,
  setMyPageTopics,
  getMyPageTopics,
  updateMyPageTopicGroups,
} = myPageSlice.actions;

export default myPageSlice.reducer;
